"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStorage = void 0;
var AppStorage = /** @class */ (function () {
    function AppStorage() {
        var _this = this;
        //set a storage value
        this.setValue = function (key, value) {
            if (_this._canStore) {
                _this._store[key] = value;
            }
        };
        this.setSessionValue = function (key, value) {
            if (_this._canStore) {
                _this._sessionStore[key] = value;
            }
        };
        //get a value by key from the store
        this.getValue = function (key) {
            if (_this._canStore) {
                var val = _this._store[key];
                return (typeof val === 'undefined') ? null : val;
            }
            return null;
        };
        //get a value by key from the store
        this.getSessionValue = function (key) {
            if (_this._canStore) {
                var val = _this._sessionStore[key];
                return (typeof val === 'undefined') ? null : val;
            }
            return null;
        };
        //get value from the store and parse it
        this.getValueFromJson = function (key, reviver) {
            if (_this._canStore) {
                if (_this._store[key] !== null && typeof _this._store[key] !== "undefined") {
                    if (reviver) {
                        return JSON.parse(_this._store[key], reviver);
                    }
                    else {
                        return JSON.parse(_this._store[key]);
                    }
                }
            }
            return null;
        };
        this.getSessionValueFromJson = function (key, reviver) {
            if (_this._canStore) {
                if (_this._sessionStore[key] !== null && typeof _this._sessionStore[key] !== "undefined") {
                    if (reviver) {
                        return JSON.parse(_this._sessionStore[key], reviver);
                    }
                    else {
                        return JSON.parse(_this._sessionStore[key]);
                    }
                }
            }
            return null;
        };
        this.setArray = function (key, value) {
            if (_this._canStore) {
                _this._store[key] = JSON.stringify(value);
            }
        };
        this.getArray = function (key) {
            if (_this._canStore) {
                if (_this._store[key] != null) {
                    return JSON.parse(_this._store[key]);
                }
            }
            return [];
        };
        this.clear = function (key) {
            if (_this._canStore) {
                _this._store.removeItem(key);
            }
        };
        //remap to local var
        this._store = localStorage;
        this._sessionStore = sessionStorage;
        this._canStore = (typeof (Storage) !== "undefined");
    }
    return AppStorage;
}());
exports.AppStorage = AppStorage;
//# sourceMappingURL=AppStorage.js.map